import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const MosaicCardFocus = styled.div<React.CSSProperties>`
  border: ${4 * Screen.widthRatio}px solid white;
  border-radius: ${24 * Screen.widthRatio}px;
  height: ${196 * Screen.widthRatio}px;
  position: absolute;
  right: ${-4 * Screen.widthRatio}px;
  top: ${-4 * Screen.widthRatio}px;
  width: ${350 * Screen.widthRatio}px;
  z-index: 1;
`;

export default MosaicCardFocus;
